import { IGSPCommonObject } from './Interface/IGSPCommonObject';
import { ElementCodeRuleConfig } from './Element/ElementCodeRuleConfig';
import { GSPCommonObjectType } from './Object/GSPCommonObjectType';
import { GSPColumnGenerate } from './Object/GSPColumnGenerate';
import { IGSPCommonElement } from './Interface/IGSPCommonElement';
import { GSPUniqueConstraint } from './Object/GSPUniqueConstraint';
import { IGSPCommonModel } from './Interface/IGSPCommonModel';
import { GSPHirarchyInfo } from './Object/GSPHirarchyInfo';
import { GspCommonDataType, GSPAssociationKey, MdRefInfo } from '../ref';
import { GSPCommonElement } from './GSPCommonElement';



/**
 * 节点元数据
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 节点元数据
 */
export class GSPCommonObject extends GspCommonDataType implements IGSPCommonObject {

  /**
   * 持久化构件
   */
  RepositoryComps: MdRefInfo[];

  /**
   * 编码规则配置
   */
  BillCodeConfig: ElementCodeRuleConfig;

  /**
   * 节点类型
   */
  ObjectType: GSPCommonObjectType;

  /**
   * 引用的数据对象标识
   */
  RefObjectName: string;

  /**
   * 是否逻辑删除
   */
  LogicDelete: boolean;

  /**
   * 列生成规则
   */
  ColumnGenerateID: GSPColumnGenerate;

  /**
   * 当前节点主键字段
   */
  get IDElement(): IGSPCommonElement {
    if (this.ColumnGenerateID != null) {
      return this.ContainElements.find(ele => ele.ID === this.ColumnGenerateID.ElementID);
    }
  }

  /**
   * 当前节点字段集合
   */
  ContainElements: GSPCommonElement[];
  // private _containElements: IGSPCommonElement[];
  // get ContainElements() {
  //   if (!this._containElements) {
  //     this._containElements = new Array<IGSPCommonElement>();
  //   }
  //   return this._containElements;
  // }

  // set ContainElements(eles: IGSPCommonElement[]) {
  //   if (eles) {
  //     this._containElements = eles;
  //   }
  // }

  /**
   * 当前节点的子节点集合
   */
  ContainChildObjects: IGSPCommonObject[];
  // private _containChildObjects: IGSPCommonObject[];
  // get ContainChildObjects() {
  //   if (!this._containChildObjects) {
  //     this._containChildObjects = new Array<IGSPCommonObject>();
  //   }
  //   return this._containChildObjects;
  // }

  // set ContainChildObjects(objs: IGSPCommonObject[]) {
  //   if (!objs) {
  //     this._containChildObjects = objs;
  //   }
  // }
  /**
   * 唯一约束集合
   */
  ContainConstraints: GSPUniqueConstraint[];

  /**
   * 父节点
   */
  // ParentObject: IGSPCommonObject;

  /**
   * 所属模型
   */
  BelongModel: IGSPCommonModel;

  /**
   * 所属模型Id
   */
  BelongModelID: string;

  /**
   * 排序表达式
   */
  OrderbyCondition: string;

  /**
   * 过滤条件表达式
   */
  FilterCondition: string;

  /**
   * 最后更新时间字段Id
   */
  ParentAssociation: boolean;

  /**
   * 创建人字段Id
   */
  CreatorElementID: string;

  /**
   * 最后修改人字段Id
   */
  ModifierElementID: boolean;

  /**
   * 是否记录已删除数据
   */
  RecordDelData: boolean;

  /**
   * 是否只读
   */
  IsReadOnly: boolean;

  /**
   * 是否非持久化
   */
  IsVirtual: boolean;

  /**
   * 状态字段
   */
  StateElementID: string;

  /**
   * 分级信息
   */
  HirarchyInfo: GSPHirarchyInfo;

  /**
   * 关联关系外键列表
   */
  Keys: GSPAssociationKey[];

  // findElementById(eleId: string): IGSPCommonElement {
  //   let result: IGSPCommonElement = null;
  //   //查找当前节点字段集合
  //   for (let i = 0; i < this.ContainElements.length; i++) {
  //     if (this.ContainElements[i].ID == eleId) {
  //       result = this.ContainElements[i];
  //       return result;
  //     }
  //   }

  //   //递归查找子节点
  //   if (this.ContainChildObjects.length > 0) {
  //     for (let i = 0; i < this.ContainChildObjects.length; i++) {
  //       result = this.ContainChildObjects[i].findElementById(eleId);
  //       if (result != null) {
  //         return result;
  //       }
  //     }
  //   }
  //   return result;
  // }

  // getAllObjectElement(): IGSPCommonElement[] {
  //   let result = this.ContainElements;
  //   if (this.ContainChildObjects.length > 0) {
  //     this.ContainChildObjects.forEach(obj => result.push(...obj.getAllObjectElement()));
  //   }
  //   return result;
  // }

  ParentObjectID: string;
}
